import React from "react";
import ActivityItem from "./item";

export default function ActivityList({ activities }) {
  const list = Array.isArray(activities) ? activities : [];
  if (list.length === 0) {
    return <div className="text-gray-600">No activity yet.</div>;
  }
  return (
    <div className="space-y-6">
      {list.slice().reverse().map((a) => (
        <ActivityItem key={a.id} activity={a} />
      ))}
    </div>
  );
}
